import React from 'react';
import PropTypes from 'prop-types';

const SuccessModal = ({ 
  isOpen, 
  onClose, 
  title = 'Success!',
  message = 'Operation completed successfully.',
  buttonText = 'OK'
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal modal-blur fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-status bg-success"></div>
          <div className="modal-body text-center py-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="icon mb-2 text-success icon-lg" width="24" height="24" 
              viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" 
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
              <path d="M9 12l2 2l4 -4" />
            </svg>
            <h3>{title}</h3>
            <div className="text-secondary">{message}</div>
          </div>
          <div className="modal-footer">
            <div className="w-100">
              <div className="row">
                <div className="col">
                  <button className="btn btn-success w-100" onClick={onClose}>
                    {buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonText: PropTypes.string
};

export default SuccessModal; 